/**
 * @generated SignedSource<<591cc88a50883a6e92a7fc26b8a726f8>>
 * @relayHash 0f5a92c40f76df5990262f7d08a413e0
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 0f5a92c40f76df5990262f7d08a413e0

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propositionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reason"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "propositionId",
        "variableName": "propositionId"
      },
      {
        "kind": "Variable",
        "name": "reason",
        "variableName": "reason"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "closeProposition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClosePropositionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClosePropositionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0f5a92c40f76df5990262f7d08a413e0",
    "metadata": {},
    "name": "ClosePropositionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "be9f0248f50418cbf7dafd5fb4a9ef24";

export default node;
